<div class="relative flex-1 flex flex-col px-base overflow-y-auto">
    <div class="sticky top-0 bg-white w-full h-12 px-1 pt-base flex justify-between items-start text-viewer-secondary text-lg">
        <div class="flex items-center justify-center gap-x-2">
            <meta-icon icon="info"></meta-icon>
            <p class="inline-block">{{'Info' | translate}}</p>
        </div>
        <button class="inline-flex items-center justify-center gap-x-2" (click)="onClose()">
            <p>{{'Close' | translate}}</p>
            <meta-icon icon="close" additionalClasses="text-base"></meta-icon>
        </button>
    </div>

    <div class="px-1 flex flex-col overflow-y-auto mt-4 pt-2 border-t border-t-gray-300">
        <div class="flex gap-x-4 mb-2">
			@if ($mainContent().cover) {
				<img class="my-auto h-20 w-20 object-cover shrink-0" [src]="$mainContent().cover" [alt]="'Cover' | translate" />
			}
			<p class="my-auto text-lg font-semibold">{{ $mainContent().title | translate}}</p>
		</div>
    </div>

    <div class="px-1 flex overflow-y-auto mt-4 pt-2 scrollbar-custom">
        @if ($mainContent().description) {
            <p class="my-auto" [innerHTML]="$mainContent().description"></p>
        }
    </div>

</div>